import React, { Component } from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';
import queryString from 'query-string';
import JobList from './JobList';
import Search from './Search';
import API from '../../../Configs';
import SkeletonContainer from '../Layout/SkeletonContainer';

class Jobs extends Component {
    title = () => {
        const { url: {location: { hash } } } = this.props;
        const query = queryString.parse(hash);
        const title = has(query,'report') ? 'Report '+query.report+' - '+API.REPORTS[query.report].reportName: 'JOBS';
        return (
            <span>
                { title } 
            </span>
        );
    }
    render(){
        const { url } = this.props;
        return (
            <SkeletonContainer title={this.title}>
                <Search />
                <JobList url={url}/>
            </SkeletonContainer>
        );
    }
}

export default connect()(Jobs);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/index.js